<svelte:options runes={true} />

<script lang="ts">
  import { getTitle } from '$lib/components/title'
  import Container from '$lib/site/Container.svelte'
</script>

<svelte:head>
  <title>{getTitle('Privacy Notice')}</title>
</svelte:head>

<Container nav padding footer>
  <div class="container prose">
    <h1>Privacy Statement</h1>
    <p>
      This privacy statement lets users of
      <a href="http://turbomaps.io/">turbomaps.io</a> <strong>(you)</strong> know when we collect your
      personal information and what we do with it.
    </p>
    <h2>What information do we collect?</h2>
    <p>You can choose to share your personal information with us when you:</p>
    <ul>
      <li>sign up for an account</li>
      <li>use our site</li>
      <li>voluntarily participate in user research</li>
    </ul>
    <p>This personal information may include your:</p>
    <ul>
      <li>name</li>
      <li>contact information</li>
      <li>location</li>
      <li>computer or network</li>
      <li>interactions with us</li>
      <li>billing or purchase information</li>
    </ul>
    <p>We will only use this information provided to us to:</p>
    <ul>
      <li>communicating with you</li>
      <li>administering, evaluating and improving the site</li>
      <li>
        improving our services (for example, by generating analytics about how our customers browse
        and interact with the site)
      </li>
    </ul>
    <h3>Sharing and disclosing your personal information</h3>
    <p>We do not share your personal information with other third parties.</p>

    <h3>How we store your data</h3>
    <p>
      Your personal data is securely stored in multiple data centres, encrypted in transit and at
      rest. All database stored customer data is backed up daily, and we test backup and restore
      capabilities annually.
    </p>
    <p>
      Your personal data will be retained until: your account is inactive for two years, or you
      delete your account. Once this occurs, we will delete all your personal information from our
      databases.
    </p>
    <h3>Data Transfer</h3>
    <p>
      Additionally, please note that your data may be transferred to multiple jurisdictions,
      including New Zealand, Europe, Singapore, and the United States as part of our data recovery
      and backup capabilities.
    </p>
    <h2>Statistical information and cookies</h2>
    <h3>
      <strong><strong>Statistical information collected</strong></strong>
    </h3>
    <p>
      We use Cloudflare Analytics to collect statistical information about your visit to help us
      improve the site. This information is aggregated and does not identify you personally.
    </p>
    <p>
      This includes information about your web browser, IP address, time zone, and some of the
      cookies that are installed on your device.
    </p>
    <h3>Cookies</h3>
    <p>
      Cookies are text files placed on your computer to collect standard Internet log information
      and visitor behavior information. When you visit our site, we may collect information from you
      automatically through cookies or similar technology.
    </p>
    <p>We use cookies in a range of ways to improve your experience on our website, including:</p>
    <ul>
      <li>keeping you logged in</li>
      <li>understanding how you use our website</li>
    </ul>
    <p>
      For further information, visit <a href="http://allaboutcookies.org/">allaboutcookies.org</a>.
    </p>
    <h3>Do not track</h3>
    <p>
      Please note that we do not alter our site’s data collection and use practices when we see a Do
      Not Track signal from your browser.
    </p>
    <h2>Your rights</h2>
    <p>
      You have the right to request for a copy of any personal information we hold about you and to
      ask that your personal information be corrected, updated, or deleted. If you would like to
      exercise this right, please contact us through the contact information below.
    </p>
    <h2>Changes</h2>
    <p>
      We may update this privacy policy from time to time and place any updates on this web page.
    </p>
    <p>This privacy notice was last updated on 13 June 2023.</p>
    <h2>How to contact us</h2>
    <p>
      For more information about our privacy practices, the data we hold on you, or you would like
      to exercise one of your data protection rights, please contact us by email at
      hello@turbomaps.io.
    </p>
    <h2><strong>If you have a privacy complaint</strong></h2>
    <p>
      If you have any concerns about how Turbomaps manages your personal information, you may
      contact us with the details above.
    </p>
    <p>
      If you are not satisfied with our response to any privacy-related concern you may have, you
      can contact the Privacy Commissioner and make a privacy complaint.
    </p>
    <p>
      <a href="https://www.privacy.org.nz/about-us/contact/"
        >Contact details for the Office of the Privacy Commissioner</a
      >
    </p>
  </div>
</Container>
